import { render, staticRenderFns } from "./_BaseButton.vue?vue&type=template&id=01fe52fe&scoped=true&"
import script from "./_BaseButton.vue?vue&type=script&lang=js&"
export * from "./_BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./_BaseButton.vue?vue&type=style&index=0&id=01fe52fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe52fe",
  null
  
)

export default component.exports